/**
 * One attachment opener in an API communication-log row: the file's type icon
 * and its name. Consumer: `ApiExpandedContent`, which renders one per archived
 * payload and one for the submission PDF.
 *
 * The icon comes from `AttachmentFileTypeIcon`, which resolves the type itself,
 * so this surface classifies nothing and cannot disagree with the panel or the
 * preview. A `Button` rather than a link, so it sits in the tab order and carries
 * no `href` a browser could navigate to — opening is a preview, and downloading
 * belongs to the overlay's own control. The caller owns `openerLabel` because
 * several expanded rows are on screen at once: each label names its log entry.
 */
import { FC } from 'react';
import { Button } from 'antd';
import { AttachmentFileTypeIcon } from '@/components/rendering/attachments/AttachmentFileTypeIcon';

interface AttachmentOpenerProps {
    fileName: string;
    declaredContentType?: string;
    openerLabel: string;
    onOpen: () => void;
}

const AttachmentOpener: FC<AttachmentOpenerProps> = ({ fileName, declaredContentType, openerLabel, onOpen }) => (
    <Button
        type="link"
        size="small"
        style={{ paddingInline: 0, height: 'auto' }}
        aria-label={openerLabel}
        onClick={onOpen}
    >
        <AttachmentFileTypeIcon fileName={fileName} declaredContentType={declaredContentType} /> {fileName}
    </Button>
);

export default AttachmentOpener;
